export const money = (n) => "$" + Math.round(Number(n || 0)).toLocaleString();
export const moneyCny = (n) => "¥" + Math.round(Number(n || 0)).toLocaleString();
// 成都账套（¥）判定：后端标 currency=CNY，或 cd 且有 ¥ 原值
export const isCnyAsset = (a) => a?.currency === "CNY" || (a?.branch === "cd" && a?.costCny != null);
// 按资产本币取值：¥ 资产优先取 {key}Cny，缺失回落 $ 值（历史未折算记录）
export const amt = (a, key) => (isCnyAsset(a) ? moneyCny(a?.[`${key}Cny`] ?? a?.[key]) : money(a?.[key]));
export const curFmt = (cnyMode) => (cnyMode ? moneyCny : money);
// 处置记录金额（proceeds.amount / gainLoss / netBook）按资产本币显示
export const prAmt = (a, pr, key) => (isCnyAsset(a) ? moneyCny(pr?.[`${key}Cny`] ?? pr?.[key]) : money(pr?.[key]));
export const inp = "mt-1 w-full text-sm rounded-md border border-slate-200 px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-400";
export const lbl = (map, key, zh) => { const v = map?.[key]; return v ? (zh ? v.zh : v.en) : (key || "—"); };
export const STATUS_CLS = {
  idle: "bg-slate-100 text-slate-600", in_use: "bg-emerald-100 text-emerald-700",
  repair: "bg-amber-100 text-amber-700", disposed: "bg-red-100 text-red-600",
};
export const COND_CLS = { ok: "bg-emerald-100 text-emerald-700", damaged: "bg-amber-100 text-amber-700", lost: "bg-red-100 text-red-600" };
export const today = () => new Date().toISOString().slice(0, 10);

export async function dlBlob(api, url, filename, open = false) {
  const { data } = await api.get(url, { responseType: "blob" });
  const u = URL.createObjectURL(data);
  if (open) window.open(u, "_blank", "noopener");
  else { const a = document.createElement("a"); a.href = u; a.download = filename; a.click(); }
  setTimeout(() => URL.revokeObjectURL(u), 8000);
}

export async function errDetail(e, fallback) {
  const d = e?.response?.data;
  if (d instanceof Blob) { try { return JSON.parse(await d.text()).detail || fallback; } catch { return fallback; } }
  return d?.detail || e?.message || fallback;
}
